import MenuMobile from "./menu-mobile.component.vue";

export default MenuMobile;
